/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExpenseFreelancerPaymentStatus = {
    None: 'NONE',
    AwaitingPayment: 'AWAITING_PAYMENT',
    Paid: 'PAID'
} as const;
export type ExpenseFreelancerPaymentStatus = typeof ExpenseFreelancerPaymentStatus[keyof typeof ExpenseFreelancerPaymentStatus];


export function instanceOfExpenseFreelancerPaymentStatus(value: any): boolean {
    for (const key in ExpenseFreelancerPaymentStatus) {
        if (Object.prototype.hasOwnProperty.call(ExpenseFreelancerPaymentStatus, key)) {
            // @ts-ignore
            if (ExpenseFreelancerPaymentStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ExpenseFreelancerPaymentStatusFromJSON(json: any): ExpenseFreelancerPaymentStatus {
    return ExpenseFreelancerPaymentStatusFromJSONTyped(json, false);
}

export function ExpenseFreelancerPaymentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseFreelancerPaymentStatus {
    return json as ExpenseFreelancerPaymentStatus;
}

export function ExpenseFreelancerPaymentStatusToJSON(value?: ExpenseFreelancerPaymentStatus | null): any {
    return value as any;
}

